import { Component } from 'preact'
import Header from '../header'
import Table from '../table/Table'
import EmptyPage from '../empty-page/EmptyPage'
import AlertComponent from '../ui-components/AlertComponent'
import LastEditedCell from './cells/LastEditedCell'

class DraftsOverview extends Component {
  constructor () {
    super()

    this.state = {
      flashMessage: null
    }
  }

  prepareTableData () {
    const urlBase = window.location.origin + '/draft/'
    let drafts = this.props.articles.map(draft => {
      draft.title = <a href={urlBase + draft.article_id}>{draft.title}</a>
      return draft
    })

    return drafts
  }

  setFlashMessage () {
    const urlParams = decodeURIComponent(window.location.search)
    if (urlParams.startsWith('?deleted')) {
      const draftTitle = urlParams.substring(urlParams.indexOf('title=') + 6)
      this.setState({ flashMessage: `Draft '${draftTitle}' has been deleted` })
    }
  }

  componentDidMount () {
    this.setFlashMessage()
  }

  render (props, state) {
    const model = [{
      header: 'Title',
      accessor: 'title'
    }, {
      header: 'Last edited',
      accessor: 'last_edited',
      cell: LastEditedCell()
    }, {
      header: 'Author',
      accessor: 'created_by'
    }, {
      header: 'Category',
      accessor: 'category'
    }]
    const rows = this.prepareTableData()
    return (
      <div>
        {state.flashMessage ? <AlertComponent sticky messageType='success' message={state.flashMessage} isVisibleFor={5000} /> : ''}
        <Header title='Drafts' disableCancelButton disableSaveButton />
        {
          !props.articles.length
            ? <EmptyPage
              img_src={`${props.defaultCdn}/images/empty_page.png`}
              header='Your draft box is empty'
              text={'Seems like no one on your team has created any draft articles. \n Start now by creating a new article'}
              button={{ link: '/content/new/article', text: 'New article' }}
            />
            : <div className='drafts-overview'>
              <Table model={model} rows={rows} rowId={'article_id'} />
            </div>
        }
      </div>
    )
  }
}

export default DraftsOverview
